export default __webpack_public_path__ + "static/media/play menu card - small.afd8f637.svg";